import { AfterViewInit, Component } from '@angular/core';
import { MeteringPointDto, MeteringPointService, MPRelationType } from '@app/api/dmc';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { InputGroupComponent } from '@shared/components/input/input-group/input-group.component';
import { SelectDirective } from '@shared/components/input/select/select.directive';
import { enumToKeyValue } from '@app/core/utils/enum-to-key-value';
import { TranslatePipe } from '@ngx-translate/core';
import { LabelDirective } from '@shared/components/input/label/label.directive';
import { InputDirective } from '@shared/components/input/input/input.directive';
import { ModalService } from '@app/core/services/modal.service';
import { ToastService } from '@app/core/services/toast.service';
import { KeyValue } from '@shared/interfaces/key-value/key-value';
import {
  MeteringpointFormAddressComponent
} from '@views/meteringpoint/meteringpoint-form-fragments/meteringpoint-form-address/meteringpoint-form-address.component';
import { GuideCardComponent } from '@shared/components/guide-card/guide-card.component';
import { HasUnsavedChanges } from '@app/core/guards/unsaved-changes.guard';

@Component({
  selector: 'app-suggest-coredata-modal',
  imports: [
    ReactiveFormsModule,
    InputGroupComponent,
    SelectDirective,
    TranslatePipe,
    LabelDirective,
    InputDirective,
    MeteringpointFormAddressComponent,
    GuideCardComponent
  ],
  templateUrl: './suggest-coredata-modal.component.html',
  styleUrl: './suggest-coredata-modal.component.css'
})
export class SuggestCoredataModalComponent implements AfterViewInit, HasUnsavedChanges {
  /** Form - MeteringPointAdministrativePartyDto **/
  public hasUnsavedChanges(): boolean {
    return this.form.dirty;
  }

  public form: FormGroup = new FormGroup({
    relationType: new FormControl({ value: null, disabled: true }, Validators.required),
    name1: new FormControl(null, Validators.required),
    name2: new FormControl(null),
    phone: new FormControl(null),
    mobile: new FormControl(null),
    email: new FormControl(null, Validators.email),
    validFrom: new FormControl(null, Validators.required),
    locationAddress: new FormGroup({
      id: new FormControl(null),
      streetName: new FormControl({ value: null, disabled: true }),
      streetCode: new FormControl({ value: null, disabled: true }),
      buildingNumber: new FormControl({ value: null, disabled: true }),
      floorIdentification: new FormControl({ value: null, disabled: true }),
      roomIdentification: new FormControl({ value: null, disabled: true }),
      subDivisionName: new FormControl({ value: null, disabled: true }),
      postalCode: new FormControl({ value: null, disabled: true }),
      cityName: new FormControl({ value: null, disabled: true }),
      municipalityCode: new FormControl({ value: null, disabled: true }),
      country: new FormControl({ value: null, disabled: true }),
      washInstructions: new FormControl({ value: null, disabled: true }),
      darReference: new FormControl({ value: null, disabled: true }),
    })
  });

  /** Dropdown Data **/
  public relationTypeOptions: KeyValue[] = enumToKeyValue(MPRelationType, { prefixValue: 'meteringpoint.coredata.addresstypes.'});

  /** Id **/
  public id?: string;

  /** MeteringPoint **/
  public meteringPoint?: MeteringPointDto;

  constructor(
    private readonly meteringPointService: MeteringPointService,
    private readonly modalService: ModalService,
    private readonly toastService: ToastService,
  ) {}

  public ngAfterViewInit(): void {
    if (this.meteringPoint) {
      const meteringPointAdministrativeParty = this.meteringPoint.detailMeteringPointPartyCharacteristic?.meteringPointAdministrativeParty;
      if (meteringPointAdministrativeParty && meteringPointAdministrativeParty.length > 0) {
        this.form.get('relationType')?.setValue(meteringPointAdministrativeParty[0].relationType);
      }
    }
  }

  public submit(): void {
    this.form.markAsTouched();
    if (this.form.valid && this.meteringPoint) {
      const party = this.form.getRawValue();

      const dto = {
        validFrom: this.form.get('validFrom')?.value,
        meteringPointAdministrativeParty: [party],
        meteringPointType: this.meteringPoint.detailCharacteristics?.meteringPointType,
      }

      this.meteringPointService
        .meteringPointProposeAdministrativePartyPost(
          dto,
          this.meteringPoint.identification!)
        .subscribe(() => {
          this.modalService.close();
          this.toastService.show('meteringpoint.coredata.suggest.success');
        }
      );
    }
  }
}
